import {useMemo} from "react";


export const randomId = () => Math.random().toString(36).slice(2);
const useRandomId = () : string => {
    return useMemo(randomId, [])
}


export default useRandomId